export enum localStorageReferences {
    SELECTED_FRONTPAGE_CARDS = 'storedSelectedForsidekort',
}
